import { globals } from "@/core/globals";
import { Logger } from "@/core/utilities";

export const getCdnUrl = (url: string) => {
  if (!url) {
    return url;
  }

  if (globals.optimizelyCdn === "" || !url.startsWith("http")) {
    return url;
  }

  try {
    const itemUrl = new URL(url);
    const itemSearch = itemUrl.search;
    return `${globals.optimizelyCdn}${itemUrl.pathname}${itemSearch}`;
  } catch (error) {
    Logger.error(`"Invalid URL: ${url}`, error);
    throw error;
  }
};

export const getShortcutCdnUrl = (url: string) => {
  if (!url || !globals.optimizelyHost || !globals.optimizelyCdn || !/^https?:\/\//i.test(url)) {
    return url;
  }

  try {
    const parsedUrl = new URL(url);
    return parsedUrl.origin === new URL(globals.optimizelyHost).origin
      ? `${getCdnUrl(parsedUrl.href)}${parsedUrl.hash}`
      : url;
  } catch {
    return url;
  }
};

export const transformUrl = (
  url: string,
  width: number = 0,
  height: number = 0,
  dpr: number = 1,
  quality: number = 90,
  format: string = "webp",
) => {
  if (!url.startsWith("http")) {
    return url;
  }

  try {
    const itemUrl = new URL(url);
    const itemUrlHost = itemUrl.host;
    const itemSearch = itemUrl.search;
    let cdnCgi = "";

    if (itemUrlHost !== "localhost:5000") {
      cdnCgi = `/cdn-cgi/image/q=${quality},f=${format},dpr=${dpr}`;
      if (width !== 0) {
        cdnCgi += `,w=${width}`;
      }
      if (height !== 0) {
        cdnCgi += `,h=${height}`;
      }
    }

    const root = globals.optimizelyCdn === "" ? `https://${itemUrlHost}` : globals.optimizelyCdn;
    return `${root}${cdnCgi}${itemUrl.pathname}${itemSearch}`;
  } catch (error) {
    Logger.error(`"Invalid URL: ${url}`, error);
    throw error;
  }
};

export const transformImageUrls = (
  images: Array<{ url: string; name: string; description: string | undefined }>,
  width: number,
  height: number,
  dpr: number = 1,
) => {
  if (!images || !Array.isArray(images) || images.length === 0) {
    return [];
  }

  try {
    return images.map((image) => {
      return {
        ...image,
        url: transformUrl(image.url, width, height, dpr),
      };
    });
  } catch (error) {
    Logger.error("Object cannot be parsed.", error);
    return images;
  }
};
